import React from 'react';
import { AdministrationContext } from 'providers/AdministrationProvider';

export function useAdministration() {
  return React.useContext(AdministrationContext);
}
